import axios from 'axios';
import { httpApi } from './http';
import type { RewardLogsResponse, RewardLogsParams } from '../types/rewardLog';

export class RewardLogService {
  // Fetch reward logs with populated reward details (single unified endpoint)
  static async getRewardLogs(params: RewardLogsParams = {}): Promise<RewardLogsResponse> {
    try {
      const response = await httpApi.get<RewardLogsResponse>('/logs_rewards', {
        params: {
          page: params.page || 1,
          limit: params.limit || 50,
          ...(params.userId && { userId: params.userId }),
          ...(params.userEmail && { userEmail: params.userEmail }),
          ...(params.userName && { userName: params.userName }),
          ...(params.resultIds && { resultIds: params.resultIds }),
          ...(params.isAuthenticated !== undefined && { isAuthenticated: params.isAuthenticated }),
          ...(params.endpoint && { endpoint: params.endpoint }),
          ...(params.method && { method: params.method }),
          ...(params.q && { q: params.q }),
          ...(params.status && { status: params.status }),
        },
      });

      if (!response.data) {
        throw new Error('No data received from server');
      }

      const raw: any = response.data;
      const page = raw.pagination?.page ?? raw.page ?? params.page ?? 1;
      const limit = raw.pagination?.limit ?? raw.limit ?? params.limit ?? 50;
      const total = raw.pagination?.total ?? raw.total ?? 0;
      const pages = raw.pagination?.pages ?? raw.pages ?? 1;

      return {
        ...raw,
        data: raw.data || [],
        pagination: { page, limit, total, pages },
      } as RewardLogsResponse;
    } catch (error) {
      console.error('Error fetching reward logs:', error);
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.message || 'Failed to fetch reward logs');
      }
      throw new Error('An unexpected error occurred');
    }
  }
}
